import { IDetailPageData } from "../../../shared/utils/api";

export interface IEntityWithReferenceField {
  id: string;
  input_field_name: string;
  field_name: string;
  field_datatype: string;
  primary_key?: boolean;
  datetime_format?: string;
  text_type?: string;
  archived?: boolean;
  distinct_values?: number;
  empty_values?: number;
  null_values?: number;
  identifying_field?: string;
  identifying_field_name?: string;
  referencing_component?: string;
  referencing_component_name?: string;
  target_datamodel_id?: string;
  target_type?: string;
}

export interface IEntityBackendType {
  id: string;
  name: string;
  datetime_format?: string;
  csv_separator?: string;
  fields: IEntityWithReferenceField[];
  archived?: boolean;
  database_connection_id?: string | null;
  intake_table_name?: string | null;
}

export function transformFromBackendEntityWithReferenceTransformer(backendType: IEntityBackendType): IDetailPageData {
  return {
    id: backendType.id,
    name: backendType.name,
    archived: backendType.archived,
    datetime_format: backendType.datetime_format,
    csv_separator: backendType.csv_separator,
    database_connection_id: backendType.database_connection_id,
    intake_table_name: backendType.intake_table_name,
    rowData: backendType.fields.map(field => {
      let result: any = { // eslint-disable-line
        id: field.id,
        input_field_name: field.input_field_name,
        field_name: field.field_name,
        field_datatype: field.field_datatype,
        empty_values: field.empty_values,
        null_values: field.null_values,
        unique_values: field.distinct_values
      };

      if (field.identifying_field) {
        result = { ...result, identifying_field: field.identifying_field };
      }

      if (field.identifying_field_name) {
        result = { ...result, identifying_field_name: field.identifying_field_name };
      }

      if (field.referencing_component) {
        result = { ...result, referencing_component: field.referencing_component };
      }

      if (field.referencing_component_name) {
        result = { ...result, referencing_component_name: field.referencing_component_name };
      }

      if (field.target_datamodel_id) {
        result = { ...result, target_datamodel_id: field.target_datamodel_id };
      }

      if (field.target_type) {
        result = { ...result, target_type: field.target_type };
      }

      if (field.field_datatype === "text") {
        result = { ...result, text_type: field.text_type };
      }

      if ((field.text_type && field.text_type !== "long_text" && field.field_datatype === "text") || field.field_datatype === "integer") {
        result = { ...result, primary_key: field.primary_key };
      }

      if (field.field_datatype === "datetime") {
        result = { ...result, datetime_format: field.datetime_format };
      }

      return result;
    })
  };
}